<script setup lang="ts">
const props = defineProps({
  to: {
    type: String,
    required: true,
  },
  primary: {
    type: Boolean,
    default: false,
  },
  secondary: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: "black",
  },
});

const getColor = computed(() => {
  return props.primary ? props.color : props.secondary ? "white" : "black";
});

const getBorderColor = computed(() => {
  return props.primary || props.secondary ? props.color : "black";
});

const getTextColor = computed(() => {
  return props.primary ? "white" : props.secondary ? props.color : "white";
});
</script>

<template>
  <NuxtLink :to="to" v-bind="$attrs" class="cta-button">
    <slot />
  </NuxtLink>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/queries";
a.cta-button {
  background-color: v-bind(getColor);
  border-color: v-bind(getBorderColor);
  border-radius: 2.5rem;
  border-style: solid;
  border-width: 3px;
  color: v-bind(getTextColor);
  font-size: clamp(1rem, 1.25vw, 1.7rem);
  font-weight: 700;
  justify-content: center;
  letter-spacing: -0.68px;
  line-height: 83%;
  padding: 0.9rem 1.9rem;
  text-align: center !important;
  text-transform: uppercase;
  transition:
    all 0.3s ease-in-out,
    color 0.3s ease-in-out;

  &:hover {
    background-color: white;
    border-color: black;
    color: black;
  }

  @include queries.for-size(device) {
    font-size: 1.7rem !important;
    width: 100%;
  }
}
</style>
